export enum ProjectRoles {
  ADMIN = 'admin',
  USER = 'user',
}
